import React from "react";
import styles from "./ProjectList.module.scss";

import ProjectListItem from "./ProjectListItem";
import { SonicProjectData } from "../../common/classes/SonicProject";
import ArchiveWrapper from "../../common/archive/ArchiveWrapper";

import AdvancedSearchProject from "./AdvancedSearchProject";

import ProjectListSort from "./ProjectListSort";
import { SearchParam } from "../../common/archive/ListSearchFunc";
import { SonicTermData } from "../../common/classes/SonicTerm";
import BackBar from "../../common/nav/BackBar";
import SwitchListButton from "../event-db/SwitchListButton";

type Props = {
  handleListTop: () => void;
  projects: Array<SonicProjectData>;
  featured: Array<SonicProjectData>;
  totalEntries: number;
  totalPage: number;
  currentPage: number;
  isLoading: boolean;
  category: string | undefined;
  perView: number;
  keywordParam: string;
  sort: string;
  isNormalArchive: boolean;
  handleArchiveType: (isNormalArchive: boolean) => void;
  handlePerView: (value: number) => void;
  handleSort: (value: string) => void;
  searchHandler: (params: Array<SearchParam>) => void;
  clearSearch: () => void;
  typeParams: Array<string>;
  gameParams: Array<string>;
  typeOptions: Array<SonicTermData>;
  gameOptions: Array<SonicTermData>;
};

export const ProjectList: React.FC<Props> = ({
  handleListTop,
  projects,
  featured,
  totalEntries,
  totalPage,
  currentPage,
  isLoading,
  category,
  perView,
  keywordParam,
  sort,
  isNormalArchive,
  handleArchiveType,
  handlePerView,
  handleSort,
  searchHandler,
  clearSearch,
  typeParams,
  gameParams,
  typeOptions,
  gameOptions,
}) => {
  return (
    <main className={styles["f-projectList__wrapper"]}>
      {/* TODO BackBarの戻るボタンが使われていなければ削除 */}
      <BackBar
        title={
          isNormalArchive ? "プロジェクト一覧" : "終了したプロジェクト一覧"
        }
        editable={false}
        handleClose={handleListTop}
      />
      <ArchiveWrapper
        title={
          isNormalArchive ? "プロジェクト一覧" : "終了したプロジェクト一覧"
        }
        hasResults={
          featured?.length === 0 && projects.length === 0 ? false : true
        }
        isLoading={isLoading}
        currentPage={currentPage}
        perView={perView}
        totalEntries={totalEntries}
        totalPages={totalPage}
        handlePerView={handlePerView}
        searchComponent={
          <>
            <SwitchListButton
              titles={["プロジェクト一覧", "終了したプロジェクト一覧"]}
              isNormalArchive={isNormalArchive}
              handleArchiveType={handleArchiveType}
            />
            <AdvancedSearchProject
              keywordParam={keywordParam}
              typeParams={typeParams}
              gameParams={gameParams}
              typeOptions={typeOptions}
              gameOptions={gameOptions}
              clearSearch={clearSearch}
              searchHandler={searchHandler}
            />
            <ProjectListSort sort={sort} handleSort={handleSort} />
          </>
        }
      >
        {category == "featured"
          ? featured.map((project, i) => (
              <ProjectListItem
                key={i}
                id={project.id}
                name={project.name}
                type={project.type}
                imgs={project.imgs}
                applicants={project.applicants}
                end_date={project.end_date}
                owner={project.owner_name}
                isJikei={
                  project.role_restriction.includes("jikei_student")
                    ? true
                    : false
                }
                isGridLayout={true}
              />
            ))
          : projects.map((project, i) => (
              <ProjectListItem
                key={i}
                id={project.id}
                name={project.name}
                type={project.type}
                imgs={project.imgs}
                applicants={project.applicants}
                end_date={project.end_date}
                owner={project.owner_name}
                isJikei={
                  project.role_restriction.includes("jikei_student")
                    ? true
                    : false
                }
                isGridLayout={true}
              />
            ))}
      </ArchiveWrapper>
    </main>
  );
};

export default ProjectList;
